import { __decorate } from "tslib";
import moment from 'moment';
import { Vue, Watch, Component } from 'vue-property-decorator';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    colors = colors;
    dateTimeFormatted = '';
    date = '';
    dataPicker = '';
    isSnapshot = false;
    pickerOptions = {
        disabledDate: (date) => moment(date).isAfter(moment().format('YYYY-MM-DD 00:00')),
        selectableRange: '',
    };
    onDataPickerChange(time) {
        let nowDay = moment(new Date()).format('YYYY-MM-DD');
        let chooseDay = moment(time).format('YYYY-MM-DD');
        // 日期是否是今日  今日则禁选未来时间
        if (nowDay === chooseDay) {
            this.pickerOptions.selectableRange = '00:00:00 - ' + moment(new Date()).format('HH:mm:ss');
        }
        else {
            this.pickerOptions.selectableRange = '00:00:00 - 23:59:59';
        }
    }
    loseFocus() {
        // 防止弹出时间选择器但是没有选时间的情况
        if (!this.date) {
            this.isSnapshot = false;
        }
    }
    onConfirm(date) {
        this.date = date || this.dataPicker;
    }
    onClick() {
        console.log(13213);
        this.date = '';
        this.dataPicker = '';
        this.isSnapshot = !this.isSnapshot;
        if (this.isSnapshot) {
            this.$refs.datePick.focus();
        }
    }
    onMouseEnter() {
        if (this.isSnapshot) {
            this.$refs.datePick.focus();
        }
    }
    onDateChange(v) {
        this.$emit('dateChange', v);
    }
};
__decorate([
    Watch('dataPicker')
], default_1.prototype, "onDataPickerChange", null);
__decorate([
    Watch('date')
], default_1.prototype, "onDateChange", null);
default_1 = __decorate([
    Component({
        name: 'snapshot',
        i18n: {
            messages: {
                'en-us': {
                    snapshot: 'Snapshot',
                },
                zh: {
                    snapshot: '快照',
                },
            },
        },
    })
], default_1);
export default default_1;
